import { render, staticRenderFns } from "./ScrollTop.vue?vue&type=template&id=0d74fd32&scoped=true&"
import script from "./ScrollTop.vue?vue&type=script&lang=js&"
export * from "./ScrollTop.vue?vue&type=script&lang=js&"
import style0 from "./ScrollTop.vue?vue&type=style&index=0&id=0d74fd32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d74fd32",
  null
  
)

export default component.exports